(function () {
  'use strict';

  /* --- Common - Start --- */

  const classHide = 'cil-hide';

  //
  //

  function commonSaveInStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
    }

    sessionStorage.setItem(key, value);
  }

  function commonReadFromStorage(key) {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue !== null) {
      return savedValue;
    }

    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function commonRemoveFromStorge(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
    }

    sessionStorage.removeItem(key);
  }

  //
  //

  function getFormattedDate(daysToAdd) {
    var today = new Date();
    var reqDate = new Date(new Date().setDate(today.getDate() + daysToAdd));

    var wk = new Intl.DateTimeFormat('en', { weekday: 'short' }).format(reqDate);
    var mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(reqDate);
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(reqDate);

    return `${wk}, ${mo} ${da}`;
  }

  /* --- Common - End --- */

  //
  //
  //
  //
  //

  /* --- Pincode Checker - Start --- */

  class CilPinCheck extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    get constants() {
      return {
        maxPincodeLen: 6,
        localStorageKeyPincode: "cil_pincheck_pincode",

        textStateUnserviceable: 'Unfortunately we do not ship to your pincode',
        msgInvalidPincode: 'Please enter a valid pincode',
        msgTryAgain: 'Please try again',
        formatGetBySingle: `Get it by {date}`,
        formatGetByRange: `Get it between {minDate} and {maxDate}`,

        classStateCheck: 'cil-state-check',
        classStateServiceable: 'cil-state-serviceable',
        classStateUnserviceable: 'cil-state-unserviceable',
        classErrorText: 'cil-error-text'
      };
    }

    connectedCallback() {
      this.dom = {
        form: this.querySelector('.cil-form'),
        inputPincode: this.querySelector('.cil-input-pincode'),
        inputProductKey: this.querySelector('.cil-input-product-key'),
        errorBox: this.querySelector('.cil-pincheck-error-box'),
        btnChange: this.querySelector('.cil-button-change'),
        btnCheck: this.querySelector('.cil-button-check'),
        textMsg: this.querySelector('.cil-text'),
        infoListServiceable: this.querySelector('.cil-list-delivery-info.cil-state-serviceable'),
        infoListUnserviceable: this.querySelector('.cil-list-delivery-info.cil-state-unserviceable')
      };

      if (this.dom.errorBox) {
        document.body.appendChild(this.dom.errorBox);
      }

      this.attachEvents();

      this.classList.remove(classHide);

      this.checkStorageAndAutoSubmit();
    }

    disconnectedCallback() {
      if (typeof PUB_SUB_EVENTS !== 'undefined') {
        document.removeEventListener(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      }
    }

    attachEvents() {
      if (this.dom.form) {
        this.dom.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submitCheck(true);
        });
      }

      if (this.dom.inputProductKey) {
        if (typeof PUB_SUB_EVENTS !== 'undefined') {
          document.addEventListener(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        }

        this.dom.inputProductKey.addEventListener('change', () => {
          this.submitCheck(false);
        });
      }

      if (this.dom.inputPincode) {
        ['change', 'keyup'].forEach(evt => {
          this.dom.inputPincode.addEventListener(evt, () => this.handleInputPincode());
        });
      }

      if (this.dom.btnChange) {
        this.dom.btnChange.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchToStateCheck();
        });
      }
    }

    handleVariantChange(e) {
      const sku = e.data.variant.sku;
      if (!!sku && this.dom.inputProductKey.value !== sku) {
        this.dom.inputProductKey.value = sku;
        this.dom.inputProductKey.dispatchEvent(new Event('change'));
      }
    }

    checkStorageAndAutoSubmit() {
      if (typeof commonReadFromStorage !== 'function') return;

      const storedPincode = commonReadFromStorage(this.constants.localStorageKeyPincode);
      if (storedPincode !== null && this.dom.inputPincode) {
        this.dom.inputPincode.value = storedPincode;
        if (this.dom.btnCheck) this.dom.btnCheck.click();
      }
    }

    handleInputPincode() {
      const el = this.dom.inputPincode;
      let value = el.value;
      const valueInt = parseInt(value, 10);

      if (!isNaN(valueInt) && valueInt) {
        value = valueInt.toString();
        el.value = (value.length <= this.constants.maxPincodeLen)
          ? value
          : value.substring(0, this.constants.maxPincodeLen);
        return true;
      }

      if (value === '') return true;
      el.value = '';
      return false;
    }

    submitCheck(shouldShowError) {
      const pincode = this.dom.inputPincode.value;
      const productKey = this.dom.inputProductKey.value;

      const pincodeInt = parseInt(pincode, 10);
      const pincodeToCheck = pincodeInt.toString();

      if (isNaN(pincodeInt) || pincodeToCheck.length !== 6) {
        if (shouldShowError) this.showError(this.constants.msgInvalidPincode);
        return;
      }

      const url = `https://pc-api.instats.io/accounts/3b33f0c7-2769-4f04-a66d-c584db5e4599/delivery/pincodes/${pincodeToCheck}?product_key=${encodeURIComponent(productKey)}`;

      fetch(url)
        .then(response => {
          if (typeof commonSaveInStorage === 'function') {
            commonSaveInStorage(this.constants.localStorageKeyPincode, pincodeToCheck);
          }

          if (response.status === 200) return response.json();
          if (response.status === 404) throw new Error('404');
          if (response.status === 400) throw new Error('400');
          throw new Error('Generic');
        })
        .then(data => {
          this.switchToStateServiceable(data);
        })
        .catch(err => {
          if (err.message === '404') {
            this.switchToStateUnserviceable();
          } else if (err.message === '400') {
            this.showError(this.constants.msgInvalidPincode);
          } else {
            this.showError(this.constants.msgTryAgain);
          }
        });
    }

    enablePincodeInput(enable) {
      if (this.dom.inputPincode) this.dom.inputPincode.disabled = !enable;
    }

    showError(msg) {
      if (!this.dom.errorBox) return;

      this.dom.errorText = this.dom.errorBox.querySelector('.cil-error-text');
      if (!this.dom.errorText) return;

      this.dom.errorText.innerText = msg;
      this.dom.errorBox.classList.remove(classHide);

      setTimeout(() => {
        this.dom.errorBox.classList.add(classHide);
      }, 3000);
    }

    switchToStateCheck() {
      this.classList.remove(this.constants.classStateServiceable, this.constants.classStateUnserviceable);
      this.classList.add(this.constants.classStateCheck);

      this.enablePincodeInput(true);

      // Clear storage and input
      if (typeof commonRemoveFromStorge === 'function') {
        commonRemoveFromStorge(this.constants.localStorageKeyPincode);
      }
      if (this.dom.inputPincode) this.dom.inputPincode.value = '';
    }

    switchToStateUnserviceable() {
      this.classList.remove(this.constants.classStateCheck, this.constants.classStateServiceable);
      this.classList.add(this.constants.classStateUnserviceable);

      this.enablePincodeInput(false);

      if (!this.dom.textMsg) return;

      if (this.dom.infoListUnserviceable) {
        this.dom.textMsg.classList.add(classHide);
      } else {
        this.dom.textMsg.innerText = this.constants.textStateUnserviceable;
        this.dom.textMsg.classList.add(this.constants.classErrorText);
        this.dom.textMsg.classList.remove(classHide);
      }
    }

    switchToStateServiceable(respJson) {
      const basicJson = respJson.data.basic;
      const customFieldsJson = basicJson.custom_fields;

      if (this.dom.infoListServiceable) {
        this.updateDeliveryInfo(basicJson);
        this.updateInstallationInfo(customFieldsJson);
      }

      this.classList.remove(this.constants.classStateCheck, this.constants.classStateUnserviceable);
      this.classList.add(this.constants.classStateServiceable);

      this.enablePincodeInput(false);
    }

    updateDeliveryInfo(basicJson) {
      const getBy = this.dom.infoListServiceable.querySelector('.cil-info-get-by');
      if (!getBy) return;

      const getByTitle = getBy.querySelector('.cil-title');

      // Check if global helper exists, otherwise this will fail
      if (typeof getFormattedDate !== 'function') {
        console.warn('getFormattedDate function is missing');
        return;
      }

      if (typeof basicJson.delivery_in_days_min === 'number' && typeof basicJson.delivery_in_days_max === 'number') {
        if (basicJson.delivery_in_days_min === basicJson.delivery_in_days_max) {
          const date = getFormattedDate(basicJson.delivery_in_days_max);
          getByTitle.innerText = this.constants.formatGetBySingle.replace('{date}', date);
        } else {
          const minDate = getFormattedDate(basicJson.delivery_in_days_min);
          const maxDate = getFormattedDate(basicJson.delivery_in_days_max);
          getByTitle.innerText = this.constants.formatGetByRange
            .replace('{minDate}', minDate)
            .replace('{maxDate}', maxDate);
        }
      } else if (basicJson.delivery_in_days) {
        const date = getFormattedDate(basicJson.delivery_in_days);
        getByTitle.innerText = this.constants.formatGetBySingle.replace('{date}', date);
      }
    }

    updateInstallationInfo(customFieldsJson) {
      const install = this.dom.infoListServiceable.querySelector('.cil-info-install');
      if (!install) return;

      const installTitle = install.querySelector('.cil-title');
      const videoLink = this.parseInstallVideoLink(install);

      const isFree = (customFieldsJson['installation_free'] || '').toLowerCase() === 'true';
      const isAvl = (customFieldsJson['installation_available'] || '').toLowerCase() === 'true';

      let reqInnerHtml = '';
      if (isFree) {
        reqInnerHtml = "Free installation is available at your location.";
      } else if (isAvl) {
        reqInnerHtml = `We’re happy to offer you a paid installation. <span>Click here to <a href="" target="_blank">add service</a>.</span>`;
      } else {
        reqInnerHtml = "We don't offer installation at your location.";
        if (videoLink) {
          reqInnerHtml += ` <span>But don't worry - Follow <a href="${videoLink}" target="_blank">this</a> installation video and do it yourself within no time!</span>`;
        }
      }
      installTitle.innerHTML = reqInnerHtml;
    }

    parseInstallVideoLink(installEle) {
      let videoLinkStr = installEle.getAttribute('data-video-link');
      if (videoLinkStr) return videoLinkStr;

      const installFaqStr = installEle.getAttribute('data-faq');
      if (!installFaqStr) return null;

      try {
        const doc = new DOMParser().parseFromString(installFaqStr, "text/html");
        const iframeEle = doc.querySelector('iframe');
        const anchorEle = doc.querySelector('a');

        if (iframeEle) videoLinkStr = iframeEle.getAttribute("src");
        else if (anchorEle) videoLinkStr = anchorEle.getAttribute("href");

        if (videoLinkStr) {
          installEle.setAttribute('data-video-link', videoLinkStr);
          return videoLinkStr;
        }
      } catch (err) {
        console.error(err);
      }
      return null;
    }
  }

  customElements.define('cil-pin-check', CilPinCheck);

  /* --- Pincode Checker - End --- */

  //
  //
  //
  //
  //

  /* --- Generic - Start --- */

  function initGeneric() {
    document.body.setAttribute('data-cil-dom-loaded', 'true');
  }

  /* --- Generic - End --- */

  //
  //
  //
  //
  //

  document.addEventListener('DOMContentLoaded', function () {
    initGeneric();

    initPincodeChecker();
  }, false);

})();